var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "container-loader"
        })
      : _c("div", [
          _vm.showHeader
            ? _c(
                "div",
                {
                  staticClass:
                    "container card card-informacoes border-radius-4px bg-light-grey"
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Processo:",
                          content: _vm.infosCadastro.numeroProcesso
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Data de criação:",
                          content: _vm.infosCadastro.dataCadastro
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Cadastrante:",
                          content: _vm.infosCadastro.cadastrante
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Modalidade do cadastro:",
                          content: _vm.infosCadastro.modalidadeCadastro
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.cadastroContainerCustomClasses }, [
            _c(
              "div",
              { staticClass: "select-versao" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c("span", [_vm._v("Versão do cadastro:")]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.handleChangeVersao },
                        model: {
                          value: _vm.versao,
                          callback: function($$v) {
                            _vm.versao = $$v
                          },
                          expression: "versao"
                        }
                      },
                      _vm._l(_vm.infosCadastro.versoes, function(versao) {
                        return _c("el-option", {
                          key: versao.id,
                          attrs: { label: versao.nome, value: versao.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container-tabs" },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: { stretch: true },
                    on: { "tab-click": _vm.handleChangeTab },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c(
                      "el-tab-pane",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loadingTab,
                            expression: "loadingTab"
                          }
                        ],
                        class: { loadingTab: "tab-loader" },
                        attrs: { label: "Cadastro", name: "CADASTRO" }
                      },
                      [
                        _c("Cadastro", {
                          attrs: {
                            cadastro: JSON.parse(_vm.cadastro.json),
                            protocolo: _vm.infosCadastro.protocolo,
                            modalidadeCadastro:
                              _vm.infosCadastro.modalidadeCadastro
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loadingTab,
                            expression: "loadingTab"
                          }
                        ],
                        class: { loadingTab: "tab-loader" },
                        attrs: { label: "Processo", name: "PROCESSO" }
                      },
                      [
                        _vm.processo
                          ? _c("Processo", {
                              attrs: { processo: _vm.processo }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loadingTab,
                            expression: "loadingTab"
                          }
                        ],
                        class: { loadingTab: "tab-loader" },
                        attrs: { label: "Histórico", name: "HISTORICO" }
                      },
                      [
                        _vm.historico
                          ? _c("Historico", {
                              attrs: { historico: _vm.historico }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-726c3778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726c3778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/VisualizacaoCadastro.vue
// module id = null
// module chunks = 